/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<g clipPath="url(#clip0_2004_10677)">
				<path
					opacity="0.4"
					d="M11 13L5.79999 11M11 13L12.923 18M11 13L13.9999 10"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M6 11.0769L5 10.6923V10.6923C3.89683 10.268 3.34524 10.0559 3.10533 9.86532C2.03578 9.0159 2.11342 7.36807 3.2581 6.62298C3.51487 6.45584 4.08396 6.29649 5.22214 5.9778L17.5217 2.53391C19.3133 2.03228 20.209 1.78147 20.8237 2.01427C21.3596 2.21724 21.7827 2.64035 21.9857 3.17628C22.2185 3.79096 21.9677 4.68672 21.466 6.47824L18.022 18.7779C17.7033 19.916 17.544 20.4851 17.3769 20.7418C16.6318 21.8865 14.9839 21.9642 14.1345 20.8945C13.944 20.6546 13.7318 20.1031 13.3076 19V19L12.923 18"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2004_10677">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<g clipPath="url(#clip0_2004_10680)">
				<path
					opacity="0.12"
					d="M21.466 6.47824C21.9677 4.68672 22.2185 3.79096 21.9857 3.17628C21.7827 2.64035 21.3596 2.21724 20.8237 2.01427C20.209 1.78147 19.3133 2.03228 17.5217 2.53391L7.29584 5.39716C4.46617 6.18947 3.05133 6.58563 2.64136 7.25828C2.28678 7.84005 2.25275 8.56231 2.55106 9.17484C2.89597 9.88306 4.26729 10.4105 7.00993 11.4654L9.67255 12.4894C10.1614 12.6775 10.4058 12.7715 10.6114 12.9176C10.7936 13.0472 10.9528 13.2064 11.0823 13.3886C11.2285 13.5942 11.3225 13.8386 11.5105 14.3275L12.5345 16.9899C13.5893 19.7326 14.1168 21.1039 14.825 21.4489C15.4375 21.7472 16.1598 21.7132 16.7415 21.3586C17.4142 20.9486 17.8104 19.5338 18.6027 16.7041L21.466 6.47824Z"
					fill="currentColor"
				/>
				<path
					d="M11 13L12.5345 16.9899C13.5893 19.7326 14.1168 21.1039 14.825 21.4489C15.4375 21.7472 16.1598 21.7132 16.7415 21.3586C17.4142 20.9486 17.8104 19.5338 18.6027 16.7041L21.466 6.47824C21.9677 4.68672 22.2185 3.79096 21.9857 3.17628C21.7827 2.64035 21.3596 2.21724 20.8237 2.01427C20.209 1.78147 19.3133 2.03228 17.5217 2.53391L7.29584 5.39716C4.46617 6.18947 3.05133 6.58563 2.64136 7.25828C2.28678 7.84005 2.25275 8.56231 2.55106 9.17484C2.89597 9.88306 4.26729 10.4105 7.00993 11.4654L11 13ZM11 13L14 10"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2004_10680">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<g clipPath="url(#clip0_2004_10688)">
				<path
					d="M6.8816 12.2192C3.45331 10.9006 1.73916 10.2413 1.30802 9.35601C0.935139 8.59034 0.977677 7.68752 1.4209 6.96031C1.93337 6.11949 3.70191 5.6243 7.239 4.63391L17.2341 1.8353C19.4735 1.20826 20.5932 0.894745 21.3615 1.18574C22.0314 1.43946 22.5603 1.96835 22.814 2.63825C23.105 3.4066 22.7915 4.5263 22.1644 6.76571L19.3657 16.7607C18.3753 20.2978 17.8801 22.0664 17.0393 22.5788C16.3121 23.022 15.4092 23.0646 14.6436 22.6917C13.7583 22.2605 13.099 20.5464 11.7805 17.118L11.0877 15.3167C10.9526 14.9654 10.8851 14.7898 10.8813 14.6152C10.878 14.4609 10.9105 14.3079 10.9762 14.1682C11.0505 14.0102 11.1836 13.8771 11.4497 13.611L14 11.0607C14.2929 10.7678 14.2929 10.2929 14 10C13.7071 9.70711 13.2322 9.70711 12.9393 10L10.3892 12.5502C10.123 12.8163 9.98997 12.9494 9.83195 13.0237C9.69227 13.0894 9.53927 13.1219 9.38495 13.1186C9.21036 13.1148 9.03472 13.0473 8.68344 12.9122L6.8816 12.2192Z"
					fill="currentColor"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2004_10688">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<g clipPath="url(#clip0_2004_10675)">
				<path
					d="M14 10L13.5 10.5L12.4705 11.5295C11.9382 12.0618 11.6721 12.3279 11.356 12.4765C11.0767 12.6079 10.7707 12.6729 10.462 12.6663C10.1129 12.6588 9.76158 12.5237 9.05902 12.2535L7.00993 11.4654C4.26729 10.4105 2.89597 9.88306 2.55106 9.17484C2.25275 8.56231 2.28678 7.84005 2.64136 7.25828C3.05133 6.58563 4.46617 6.18947 7.29584 5.39716L17.5217 2.53391C19.3133 2.03228 20.209 1.78147 20.8237 2.01427C21.3596 2.21724 21.7827 2.64035 21.9857 3.17628C22.2185 3.79096 21.9677 4.68672 21.466 6.47824L18.6027 16.7041C17.8104 19.5338 17.4142 20.9486 16.7415 21.3586C16.1598 21.7132 15.4375 21.7472 14.825 21.4489C14.1168 21.1039 13.5893 19.7326 12.5345 16.9899L12.3461 16.5L12.1538 16"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2004_10675">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<g clipPath="url(#clip0_2004_10673)">
				<path
					d="M11 13L12.5345 16.9899C13.5893 19.7326 14.1168 21.1039 14.825 21.4489C15.4375 21.7472 16.1598 21.7132 16.7415 21.3586C17.4142 20.9486 17.8104 19.5338 18.6027 16.7041L21.466 6.47824C21.9677 4.68672 22.2185 3.79096 21.9857 3.17628C21.7827 2.64035 21.3596 2.21724 20.8237 2.01427C20.209 1.78147 19.3133 2.03228 17.5217 2.53391L7.29584 5.39716C4.46617 6.18947 3.05133 6.58563 2.64136 7.25828C2.28678 7.84005 2.25275 8.56231 2.55106 9.17484C2.89597 9.88306 4.26729 10.4105 7.00993 11.4654L11 13ZM11 13L13.5 10.5"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2004_10673">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<g clipPath="url(#clip0_2004_10683)">
				<path
					opacity="0.32"
					d="M7.36683 4.59817L17.234 1.83536C19.4734 1.20832 20.5931 0.894806 21.3615 1.1858C22.0314 1.43952 22.5603 1.96841 22.814 2.63831C23.1049 3.40666 22.7914 4.52637 22.1644 6.76577L19.4015 16.6327C18.4016 20.2036 17.9017 21.9891 17.0575 22.5014C16.3274 22.9444 15.4217 22.9841 14.6557 22.6067C13.7698 22.1703 13.1156 20.4354 11.807 16.9656L11.1384 15.1927C10.9034 14.5698 10.786 14.2583 10.601 13.9967C10.4372 13.765 10.235 13.5628 10.0033 13.3989C9.74174 13.214 9.43026 13.0965 8.80729 12.8616L8.80728 12.8616L7.03377 12.1927C3.56413 10.8841 1.82932 10.2298 1.39291 9.34392C1.01551 8.57789 1.05523 7.67221 1.49824 6.94216C2.01052 6.09793 3.79596 5.59801 7.36683 4.59817Z"
					fill="currentColor"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M10.3276 13.6722C10.4276 13.7721 10.5191 13.8806 10.6011 13.9965C10.786 14.258 10.9035 14.5695 11.1384 15.1925L11.807 16.9654L11.807 16.9654C13.1156 20.4351 13.7699 22.17 14.6557 22.6064C15.4217 22.9839 16.3274 22.9441 17.0575 22.5011C17.9017 21.9889 18.4017 20.2034 19.4016 16.6325L22.1644 6.76553C22.7915 4.52612 23.105 3.40642 22.814 2.63807C22.6872 2.30317 22.4916 2.00351 22.2439 1.75586L10.3276 13.6722Z"
					fill="currentColor"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2004_10683">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</Fragment>,
	],
]);
